module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av690-fdd70dd245e8e4b022422d8143f8cb48.jpg";